// extracted by mini-css-extract-plugin
module.exports = {"Container":"_24_ZhH","Large":"pZiAmd","Medium":"LgEq2s","Small":"H2z_Pj","Full":"mxm17X"};